var React = require('react');

function IconSmartStart (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-550 -173)"},[React.createElement("circle",{"cx":"250","cy":"250","r":"250","transform":"translate(550 173)","fill":"#10457a","key":0}),React.createElement("path",{"d":"M775.217 299.791a15.254 15.254 0 00.256 21.934l77.058 73.416H668.743a15.311 15.311 0 00-15.348 15.345v20.464a15.311 15.311 0 0015.348 15.348h183.788l-77.058 73.413a15.365 15.365 0 00-.256 21.934l14.2 14.2a15.283 15.283 0 0021.678 0l124.314-124.32a15.284 15.284 0 000-21.679L811.095 285.594a15.283 15.283 0 00-21.678 0z","fill":"#fff","key":1})]));
}

IconSmartStart.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = IconSmartStart;

IconSmartStart.default = IconSmartStart;
